<template>
    <div class="accordion" id="accordionExample">
      <div 
        class="accordion-item"
        data-aos="fade-left" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="100" 
        data-aos-duration="500"
        >
        <h4 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseUno" aria-expanded="false" aria-controls="collapseUno">
            <img src="../assets/svg/forma_celeste_2.svg" alt="" class="curve-icon">
            <h5>¿En qué zonas prestan servicios?</h5>
          </button>
        </h4>
        <div id="collapseUno" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-center">
            <p class="ws-16">
              Actualmente operamos en Copiapó y alrededores, con planes de expansión regional. Nuestra lavandería está ubicada en Rafael Torreblanca 424, Copiapó-Chile y nuestro horario de atención es de lunes a viernes entre 8:00 y 18:00 hrs.
            </p>
          </div>
        </div>
      </div>

      <div 
        class="accordion-item"
        data-aos="fade-left" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="150" 
        data-aos-duration="500"
        >
        <h4 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDos" aria-expanded="false" aria-controls="collapseDos">
            <img src="../assets/svg/forma_celeste_profundo.svg" alt="" class="curve-icon">
            <h5>¿Cómo es el proceso de contratación del servicio?</h5>
          </button>
        </h4>
        <div id="collapseDos" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-center">
            <p class="ws-16">
              Una vez que nos contactas, coordinamos el servicio que necesitas. Si es lavandería puedes venir a dejar las prendas, si es alimentación coordinamos la entrega según lo requerido.
            </p>
          </div>
        </div>
      </div>
      <div 
        class="accordion-item"
        data-aos="fade-left" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="200" 
        data-aos-duration="500"
        >
        <h4 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCuatro" aria-expanded="false" aria-controls="collapseCuatro">
            <img src="../assets/svg/forma_rosa.svg" alt="" class="curve-icon">
            <h5>¿Ofrecen servicios para empresas pequeñas?</h5> 
          </button>
        </h4>
        <div id="collapseCuatro" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-center">
            <p class="ws-16">
              Atendemos tanto a grandes compañías como a contratistas, empresas medianas y pequeñas. Lo importante para nosotras es entregar el mejor servicio a quien requiera de nuestro apoyo.
            </p>
          </div>
        </div>
      </div>
      <div 
        class="accordion-item"
        data-aos="fade-left" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="250" 
        data-aos-duration="500"
        >
        <h4 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeis" aria-expanded="false" aria-controls="collapseCuatro">
            <img src="../assets/svg/forma_celeste_2.svg" alt="" class="curve-icon">
            <h5>¿Ofrecen servicios a personas individuales?</h5> 
          </button>
        </h4>
        <div id="collapseSeis" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-center">
            <p class="ws-16">
              Sí. Sólo debes llevar tu ropa a nuestra sucursal ubicada en <a href="https://maps.app.goo.gl/X7JeMfwj1zCM8Vdz5">Rafael Torreblanca 424, Copiapó.</a> El horario de atención es de lunes a viernes entre 8:00 y 18:00 hrs.
            </p>
          </div>
        </div>
      </div>
      <div 
        class="accordion-item"
        data-aos="fade-left" 
        data-aos-easing="ease-in-sine" 
        data-aos-offset="300" 
        data-aos-duration="500"
        >
        <h4 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTres" aria-expanded="false" aria-controls="collapseTres">
            <img src="../assets/svg/forma_verde_2.svg" alt="" class="curve-icon">
            <h5>¿Qué medidas toman respecto a la sustentabilidad?</h5>
          </button>
        </h4>
        <div id="collapseTres" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-center">
            <p class="ws-16">
              Optimizamos el uso del agua y los insumos en nuestros procesos de lavandería y alimentación, y trabajamos con estrategias de reutilización y eficiencia energética.
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "AccordionDudas"
};
</script>

